// src/features/editor/components/blocks/previews/QuizBlockPreview.tsx
// Router: dispatches to the per-subtype preview based on quizType.
import type { QuizBlock } from '@/types/blocks'
import type { ContentLang } from '@/features/editor/editorSlice'
import type { PreviewRun } from '../../preview/previewRun'
import { ChoiceQuizPreview } from './ChoiceQuizPreview'
import { YesNoQuizPreview } from './YesNoQuizPreview'
import { FillBlankQuizPreview } from './FillBlankQuizPreview'

interface Props {
  block: QuizBlock
  contentLang: ContentLang
  /** Прохождение — прокидывается подтипу как есть. */
  run?: PreviewRun
}

export const QuizBlockPreview = ({ block, contentLang, run }: Props) => {
  const quizType = block.quizType ?? 'choice'
  switch (quizType) {
    case 'yes_no':
      return <YesNoQuizPreview block={block} contentLang={contentLang} run={run} />
    case 'fill_blank':
      return <FillBlankQuizPreview block={block} contentLang={contentLang} run={run} />
    default:
      return <ChoiceQuizPreview block={block} contentLang={contentLang} run={run} />
  }
}
